export { inputStyle, buttonStyle, primaryButtonStyle }

// Shared styles for the dashboard's inline-styled forms, mirroring vike.dev/free's <FreeTrialForm>:
//   inputStyle          — the text field (48px, light border); the same field renders on /free.
//   buttonStyle         — the quiet "family-B" submit (light gray, dark text): the dashboard panels'
//                         button and /free's form submit. Deliberately subdued — on those pages the
//                         submit isn't the page's primary action, so it shouldn't shout.
//   primaryButtonStyle  — the bold dark CTA mirroring the landing-page "Get Started" button; used only
//                         by <Login>, whose sign-in IS its page's primary action (full-width there).
//
// Layout differs by surface: the panels put field + button on one flex row (auto-width button), while
// <Login> stacks them in a grid (so its button goes full-width). The license-components <FreeTrialForm>
// keeps its own copies — it ships as a standalone npm package and doesn't import dashboard internals
// (only the wire/snippet contracts, via symlink) — so /free's free-trial-form.css is the upstream
// original those mirror.
const inputStyle = {
  width: '100%',
  height: 48,
  padding: '0 14px',
  fontSize: 16,
  boxSizing: 'border-box',
  color: 'inherit',
  background: '#fff',
  border: '1px solid #d4d4d4',
  borderRadius: '5.6px',
} as const
// Both buttons are the same 48px pill (borderless, so the height matches the input's border-box 48px);
// they differ only in fill + text colour — see the header for which surface uses which.
const buttonBase = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 48,
  padding: '0 20px',
  border: 0,
  borderRadius: '5.6px',
  fontSize: 18,
  fontWeight: 600,
  cursor: 'pointer',
} as const
const buttonStyle = { ...buttonBase, background: 'oklch(0.92 0 0)', color: 'oklch(0.35 0 0)' } as const
const primaryButtonStyle = { ...buttonBase, background: 'oklch(0.32 0 0)', color: '#fdfdfd' } as const
